import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=133dd9f6&scoped=true&lang=html&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=133dd9f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133dd9f6",
  null
  
)

component.options.__file = "Home.vue"
export default component.exports